/* eslint @typescript-eslint/no-var-requires: "off" */
const OSS = require('ali-oss')

export default function Client(data) {
  return new OSS({
    region: data.region,  //oss-cn-beijing-internal.aliyuncs.com
    accessKeyId: data.accessKeyId,
    accessKeySecret: data.accessKeySecret,
    stsToken: data.stsToken,
    bucket: data.bucket
  })
}